import { FIELDS } from 'queries/query-keys';
import { useQuery } from '@tanstack/react-query';
import FieldService from 'services/FieldService';

export const useField = ({ id, isClient, model }) => {
  return useQuery({
    queryKey: FIELDS.GET_FIELD(id),
    queryFn: () => {
      return isClient
        ? FieldService.getClientField(id)
        : FieldService.getField(id, model);
    },
    enabled: Boolean(id) && Boolean(model),
  });
};
